import React, { useContext } from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import { ThirdPartyDisclosure } from './ThirdPartyDisclosure';

export const ThirdPartyDisclosureRoute = () => {
  useContext(ExperienceContext);
  const contentfulEnabled = useConfigService('contentful.third_party_disclosure.enabled');

  const defaultVariables = {
    keyword: null,
    slug: 'privacy/third-party-disclosure-list'
  };

  return (
    <QueryProvider cacheKey="customer-data-governance-third_party_disclosure" defaultVariables={defaultVariables}>
      <ThirdPartyDisclosure contentfulEnabled={contentfulEnabled} />
    </QueryProvider>
  );
};
